<template>
    <div class="order">
        <div class="order-list-wrap">
            <van-search
                    placeholder="请输入姓名/职位/订单ID等"
                    v-model="keyword"
                    shape="round"
                    left-icon=""
                    @search="onSearch">
            </van-search>
            <filter-nav type="order"></filter-nav>
            <h2 v-if="unReadCount" class="info-tip">您有 <b class="green">{{unReadCount}}</b> 个未处理订单<b class="un-read green"
                                                                                       @click="changeUnRead">{{unRead ?
                "查看全部": "查看未读"}}</b></h2>
            <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
                <van-list
                        v-if="(list && list.length) || loading"
                        v-model="loading"
                        :finished="finished"
                        :immediate-check="false"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <order-list v-for="(item,index) in list" :key="index" :candidate="item"></order-list>
                </van-list>
                <no-data v-else></no-data>
            </van-pull-refresh>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .order-list-wrap {
        width: 100%;
        background-color: #f5f5f5;

        .info-tip {
            padding: 0 18px;
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: #333;
            .un-read {
                font-weight: normal;
                margin-left: 20px;
            }
        }
    }
</style>
<style lang="scss">
    .order-list-wrap {
        .van-search {
            padding: 10px 15px;
        }
    }
</style>
<script>
  import orderList from "@/components/order/list";
  import FilterNav from "@/components/order/filterNav";
  import { getCandidateCount, getCandidateList, getUserInfo } from "@/api/order";
  import { mapState } from "vuex";
  import NoData from "@/components/noData";
  export default {
    name: "order-module",
    data() {
      return {
        list: [],
        loading: false,//控制上拉加载的加载动画
        finished: false,//上拉加载完毕
        isDownLoading: false,//控制下拉刷新的加载动画
        pageNo: 1,
        pageSize: 10,
        unReadCount: "",
        unRead: false,
        keyword: this.$route.query.keyword || "",
        userId: ""
      };
    },
    components: {
      orderList, FilterNav, NoData
    },
    computed: {
      ...mapState({
        getUserInfo: state => state.comp.userInfo || {}
      })
    },
    methods: {
      changeUnRead() {
        this.unRead = !this.unRead;
        this.pageNo = 1;
        this.finished = false;
        this.loading = true;
        this.getList();
      },
      getCount() {
        let params = {
          status: (this.$route.query.status || this.$route.query.phase) ? (this.$route.query.status || this.$route.query.phase) : 1,
          unRead: 1,
          hunterIds: this.getUserInfo.userId || this.userId,
          keyword: this.keyword ? this.keyword : undefined
        };
        getCandidateCount(params).then(res => {
          this.unReadCount = res && res.data && res.data.total ? res.data.total : "";
        }).catch(err => {
          console.log(err, "err");
        });
      },
      getList() {
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          sortType: this.$route.query.sortType || 2,
          status: this.$route.query.status || this.$route.query.phase ? (this.$route.query.status || this.$route.query.phase) : 1,
          hunterIds: this.getUserInfo.userId || this.userId,
          unRead: this.unRead ? 1 : undefined,
          keyword: this.keyword ? this.keyword : undefined
        };
        getCandidateList(params).then(res => {
          if (res && res.data) {
            if (res.data.candidates && res.data.candidates.length) {
              if (this.pageNo == 1) {
                this.list = res.data.candidates;
              } else {
                this.list = this.list.concat(res.data.candidates);
              }
              if (res.data.candidates.length < this.pageSize) {
                //最后一页不足10条
                this.finished = true;
              } else {
                this.pageNo++;
              }
            } else {
              //加载结束
              this.finished = true;
            }
          }
        }).catch(err => {
          console.log(err, "err");
        }).finally(() => {
          this.isDownLoading = false;
          this.loading = false;
        });
      },
      //下拉刷新
      onDownRefresh() {
        this.pageNo = 1;
        this.unRead = false;
        this.finished = false;
        this.isDownLoading = true;
        this.init(); //加载数据
      },
      //上拉加载请求
      onLoad() {
        this.loading = true;
        this.getList();
      },
      init() {
        if (!this.getUserInfo.userId) {
          getUserInfo().then(res => {
            if (res && res.data && res.data.userId) {
              this.userId = res.data.userId;
              this.getList();
              this.getCount();
            }
          }).catch(err => {
            console.log(err, "err");
          });
        } else {
          this.getList();
          this.getCount();
        }
      },
      onSearch() {
        let params = { ...this.$route.query };
        params.keyword = this.keyword;
        if (!this.keyword)
          delete params.keyword;
        this.$router.replace({ name: this.$route.name, query: { ...params } });
      }
    },
    watch: {
      $route(n, o) {
        this.list = [];
        this.pageNo = 1;
        this.unRead = false;
        this.finished = false;
        this.loading = true;
        this.init();
      }
    },
    created() {
      this.loading = true;
      this.init();
    }
  };
</script>
